<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells">
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">编号</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.em_code" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">姓名</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.em_name" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell weui-cell_select weui-cell_select-after">
          <div class="weui-cell__hd">
            <label for class="weui-label">性别</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.em_sex"
              placeholder="请选择"
            >
              <option>男</option>
              <option>女</option>
            </select>
          </div>
        </div>
        <div class="weui-cell weui-cell_select weui-cell_select-after">
          <div class="weui-cell__hd">
            <label for class="weui-label">婚姻状态</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.em_marital"
              placeholder="请选择"
            >
              <option>已婚</option>
              <option>未婚</option>
            </select>
          </div>
        </div>
        <div class="weui-cell weui-cell_select weui-cell_select-after">
          <div class="weui-cell__hd">
            <label for class="weui-label">学历</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.em_xl"
              placeholder="请选择"
            >
              <option>小学</option>
              <option>初中</option>
              <option>中专</option>
              <option>高中</option>
              <option>大专</option>
              <option>本科</option>
              <option>硕士研究生</option>
              <option>博士研究生</option>
            </select>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">专业</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.em_zy" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">毕业院校</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.em_byschool" placeholder="请填写" />
          </div>
        </div>
        <role-field v-model="form.roles" @select="onSelectRole" />
        <department-field v-if="form.main" v-model="form.main.dp_name" @select="onSelectDepartment" />
        <department-field v-else v-model="form.dp_name" @select="onSelectDepartment" />
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">手机</label>
          </div>
          <div class="weui-cell__bd">
            <input
              v-if="mobileEditable"
              class="weui-input"
              type="text"
              v-model="form.em_mobile"
              placeholder="请填写"
            />
            <span v-else>{{form.em_mobile}}</span>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">邮箱</label>
          </div>
          <div class="weui-cell__bd">
            <input
              v-if="emailEditable"
              class="weui-input"
              type="text"
              v-model="form.em_email"
              placeholder="请填写"
            />
            <span v-else>{{form.em_email}}</span>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">地址</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.em_address" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">身份证号</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.em_id_card" placeholder="请填写" />
          </div>
        </div>
        <date-field
          :label="'入职时间'"
          v-model="form.em_entry_time"
        />
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">紧急联系人</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.em_emergencyname" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">联系人关系</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.em_emergencygx" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">联系人电话</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="number" v-model="form.em_emergencytel" placeholder="请填写" />
          </div>
        </div>
        <date-field
          :label="'转正时间'"
          v-model="form.em_positivetime"
        />
        <date-field
          :label="'合同开始'"
          v-model="form.em_co_starttime"
        />
        <date-field
          :label="'合同结束'"
          v-model="form.em_co_endtime"
        />
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">保存</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>
import DepartmentField from "@/components/field/DepartmentField.vue";
import RoleField from "@/components/field/RoleField.vue";
import DateField from "@/components/field/DateField.vue"
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  components: {
    DepartmentField,
    RoleField,
    DateField
  },
  data() {
    return {
      baseUrl: "/api/document/employee",
      // 暂不允许直接修改手机号、邮箱
      mobileEditable: true,
      emailEditable: true,
      form: {
        em_code: null
      }
    };
  },
  mounted() {
    var me = this;
    if(!me.$route.query.id) me.getMaxnumber()
  },
  methods: {
    getMaxnumber() {
      var me = this
      me.$loading({
        url: "/api/commons/number/getMaxnumber",
        method: 'POST',
        params: {
          caller: 'Employee'
        },
      }).then(function (res) {
        if (res.success) {
          me.form = Object.assign({}, me.form, {em_code: res.data})
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      })
    },
    /**
     * 读取数据，原read接口返回的数据不完整，改为使用list接口
     * @override
     */
    f_get(callback, id) {
      var me = this;
      id = id || me.initId || me.$route.params.id || me.$route.query.id;
      if (id) {
        me.$loading({
          url: me.baseUrl + "/list",
          params: {
            condition: JSON.stringify({
              field: "em_id",
              operation: "=",
              value: id,
            }),
          },
        }).then(function (res) {
          if (res.success) {
            me.form = res.data.list[0];
            me.mobileEditable = !me.form.em_mobile;
            me.emailEditable = !me.form.em_email;
            if (callback && typeof callback === "function") {
              callback.call(me, me.form);
            }
          } else {
            me.$router.push({
              name: "Error",
              params: res
            });
          }
        });
      } else if (me.initData) {
        me.form = me.initData;
      }
    },
    save() {
      var me = this,
        main = me.form;
      if (!main.em_name) {
        me.$weui.topTips("请填写姓名", 2000);
      } else if (!main.roleIds || !main.roles) {
        me.$weui.topTips("请选择岗位", 2000);
      }
      else if (!main.em_mobile) {
        me.$weui.topTips("请填写手机号", 2000);
      } 
      else {
        if(!main.em_dpid) {
          main.em_dpid = main.main.em_dpid
          main.departmentDTO = main.main.departmentDTO
        }
        me.f_save();
      }
    },
    onSelectDepartment(selection) {
      var me = this,
        main = me.form;
      main.em_dpid = selection.id;
      main.departmentDTO = selection;
    },
    onSelectRole(selected) {
      var me = this,
        main = me.form;
      main.roleIds = selected.map((item) => item.id).join(",");
    },
  },
};
</script>